import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";
//import { AppHeaderComponent } from "./shared/components/app-header/app-header.component";
import { RouterModule } from "@angular/router";
import { AgTeachersModule } from "./ag-teachers/ag-teachers.module";
import { RegistrationComponent } from "./registration/registration.component";
import { RegistrationModule } from "./registration/registration.module";
import { AppFooterComponent } from "./shared/components/app-footer/app-footer.component";
import { AppSidebarComponent } from "./shared/components/app-sidebar/app-sidebar.component";

@NgModule({
    declarations: [
        AppComponent,
        //AppHeaderComponent,
        AppFooterComponent,
        AppSidebarComponent
    ],
    imports: [
        SharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RegistrationModule,
        RouterModule.forRoot([
            { path: '', redirectTo: 'registration', pathMatch: 'full' },
            { path: 'registration', component: RegistrationComponent, data: { paymentStatus: undefined } },
            { path: 'registration/payment/:exhibitorId/cancelled', component: RegistrationComponent, data: { paymentStatus: 'cancelled' } },
            { path: 'registration/payment/:exhibitorId/status', component: RegistrationComponent, data: { paymentStatus: 'status' } },
            { path: '**', redirectTo: '/', pathMatch: 'full' }
        ], { scrollPositionRestoration: 'top' }),
        AgTeachersModule
    ],
    providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

    constructor() {
        console.log("App started.");
    }
}